import { gql } from '@apollo/client';

export const GET_INSPECTION_GROUPS = gql`
  query GetInspectionGroups($project_id: Int!) {
    weld_inspection_groups(project_id: $project_id) {
      id
      inspection_category_type_id
    }
  }
`;
